import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Skeleton, Space} from 'antd';
import {
  StyledUnmatchedTotals,
  StyledUnmatchedTotalsItem,
  StyledUnmatchedTotalsItemMark,
  StyledUnmatchedTotalsItemValue
} from './StyledUnmatchedTotals';
import {amountHelpers, invoicesHelpers} from '../../../../../utils/helpers';

const sortedStatusKeys = ['upcoming', 'due', 'overdue']; // Preserving the correct order

const UnmatchedTotals = ({
  data = {},
  loading = false,
  ...rest
}) => {
  const [t] = useTranslation('main');

  return (
    <StyledUnmatchedTotals
      size={32}
      {...rest}
    >
      {sortedStatusKeys.map(key => {
        const status = invoicesHelpers.getInvoicePaymentStatus(key.toUpperCase());
        const {color, key: statusKey} = status;
        const amount = data?.[key] || 0;

        return (
          <StyledUnmatchedTotalsItem
            color={color}
            key={key}
          >
            {t(statusKey)}
            <Space size='small'>
              <StyledUnmatchedTotalsItemMark color={color} />
              {loading ? (
                <Skeleton.Node active style={{ width: 95, height: 20 }} />
              ) : (
                <StyledUnmatchedTotalsItemValue>
                  {amountHelpers.getAmountWithCurrencyCode(amount ?? 0)}
                </StyledUnmatchedTotalsItemValue>
              )}
            </Space>
          </StyledUnmatchedTotalsItem>
        )
      })}
    </StyledUnmatchedTotals>
  );
}

UnmatchedTotals.propTypes = {
  data: PropTypes.shape({
    due: PropTypes.number,
    overdue: PropTypes.number,
    upcoming: PropTypes.number,
  }),
  loading: PropTypes.bool,
};

export default UnmatchedTotals;
